import { Injectable } from '@angular/core';

@Injectable()
export class ConstantService {

    //public baseURL: string = "https://private-aa34b-jointlyapi.apiary-mock.com";
    //public baseURL: string = "http://ec2-54-213-200-121.us-west-2.compute.amazonaws.com:3030";
    // public baseURL: string = "http://localhost:3030";
    //public baseURL: string = "http://192.168.50.78:3030"
    //public baseURL: string = "http://ec2-3-101-53-187.us-west-1.compute.amazonaws.com/";
      public baseURL: string = "https://mobile.collablinks.com/";

    public hashingSalt: string = "s0mRIdlKvI";

    constructor() { }

}



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/constants/constant.service.ts